import {
  ChangeDetectorRef,
  Component,
  effect,
  HostListener,
  inject,
  Signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CorporateDesignStore } from '../../../services/api/corporate-design/corporate-design-store.service';
import { ReactiveFormsModule } from '@angular/forms';
import { BannerComponent } from '../../../components/data-display/banner/banner.component';
import { LoadingAnimationComponent } from '../../../components/feedback/loading-animation/loading-animation.component';
import {
  CONFIGURATION_SETTING_KEYS,
  EEntityType,
  ERelationType,
  ETicketType,
  IConfiguration,
} from '@web/dtos';
import { ConfigurationStore } from '../../../services/api/configuration/configuration-store.service';
import { CustomTilesComponent } from '../../../components/data-display/custom-tiles/custom-tiles.component';
import { EPage } from '../../../components/feedback/direct-ticket-configuration-shopping-cart/direct-ticket-configuration-shopping-cart.component';
import { EqualizingService } from '../../../services/support/equalizing-support/equalizing.service';
import { Router } from '@angular/router';
import { ERoute } from '../../../constants/routes.enum';

@Component({
  selector: 'aw-landing-page',
  imports: [
    CommonModule,
    BannerComponent,
    ReactiveFormsModule,
    LoadingAnimationComponent,
    CustomTilesComponent,
  ],
  templateUrl: './landing-page.component.html',
  styles: ``,
})
export class LandingPageComponent {
  protected readonly configurationStore: ConfigurationStore =
    inject(ConfigurationStore);
  protected readonly corporateDesignStore: CorporateDesignStore =
    inject(CorporateDesignStore);
  private readonly equalizingService: EqualizingService =
    inject(EqualizingService);
  private readonly cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly router: Router = inject(Router);

  public readonly configuration: Signal<IConfiguration[]> =
    this.configurationStore.configuration;
  protected readonly EPage: typeof EPage = EPage;

  protected readonly ETicketType: typeof ETicketType = ETicketType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly ERelationType: typeof ERelationType = ERelationType;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.equalize();
  }

  constructor() {
    effect(() => {
      const shopConfig: IConfiguration[] = this.configuration();
      if (
        shopConfig &&
        !this.configurationStore.getBooleanConfiguration(
          CONFIGURATION_SETTING_KEYS.IsCustomTilePageActive
        ) &&
        !this.configurationStore.isLoading()
      ) {
        if (
          this.configurationStore.getBooleanConfiguration(
            CONFIGURATION_SETTING_KEYS.IsDirectSaleActive
          )
        ) {
          this.router.navigate([`/${ERoute.directTickets}`]);
        } else if (
          this.configurationStore.getBooleanConfiguration(
            CONFIGURATION_SETTING_KEYS.IsSubscriptionActive
          )
        ) {
          this.router.navigate([`/${ERoute.subscriptions}`]);
        }
      }
    });
  }

  protected equalize(): void {
    this.cdRef.detectChanges();
    const toEqual = ['upper-ticket-segment', 'lower-ticket-segment'];
    this.equalizingService.equalize(toEqual);
  }

  protected readonly CONFIGURATION_SETTING_KEYS = CONFIGURATION_SETTING_KEYS;
}
